import React, { ReactNode } from "react";
interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  intro?: ReactNode;
  dark?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-292" data-mp="3f2n7hz61iurj">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.14em] md:text-sm ${dark ? "text-accent" : "text-brand"}`} data-id="element-293" data-mp="3k1883zp7fggi">
          {eyebrow}
        </p>}
      <h2 className="mt-3 font-display text-[28px] font-extrabold leading-[1.1] md:text-5xl" data-id="element-294" data-mp="gjgjmvaa1en2">{title}</h2>
      {intro && <div className={`mt-5 space-y-3 text-base leading-relaxed md:text-lg ${dark ? "text-white/75" : "text-muted"}`} data-id="element-295" data-mp="1vc05p3egz38">
          {intro}
        </div>}
    </div>;
}